import { React, useState, useEffect, useRef, useContext } from "react";
import Select from 'react-select';
import Button from "@mui/material/Button";
import axios from "axios";
import { AppContext } from '../../../../AppStore';
import GridNoRow from '../../../../common/GridNoRow';
import { DataGrid, GridActionsCellItem, useGridApiRef } from '@mui/x-data-grid';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import DownloadIcon from '@mui/icons-material/Download';
import Swal from "sweetalert2";
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import OrderSelectModal from "../../../../modal/PC/common/OrderSelectModal";
import OutgoingSelectModal from "../../../../modal/PC/common/OutgoingSelectModal";
import PartnerUserSelectModal from "../../../../modal/PC/common/PartnerUserSelectModal";
import ItemSelectModal from "../../../../modal/PC/common/ItemSelectModal";
import UserSelectModal from "../../../../modal/PC/common/UserSelectModal";
import Moment from 'moment';
import "moment/locale/ko";

let newFileID = 1;
let realFiles = [];
let tmpRealFiles = [];
function TAB_OutgoingUpdate({ title, onClose, id, originRows, handleView, userTypeModalOption, qualityYnModalOption, MenuUpdateYN}) {
  const appStore = useContext(AppContext);
  const apiRef = useGridApiRef();
  const tabPanelRef = useRef();
  const [tabPanelHeight, setTabPanelHeight] = useState(0);
  const [originItemRows, setOriginItemRows] = useState([]);
  const [itemRows, setItemRows] = useState([]);
  const [updateItemRows, setUpdateItemRows] = useState([]);
  const [itemColumns, setItemColumns] = useState([]);
  const [originLotRows, setOriginLotRows] = useState([]);
  const [lotRows, setLotRows] = useState([]);
  const [updateLotRows, setUpdateLotRows] = useState([]);
  const [lotColumns, setLotColumns] = useState([]);
  const [userRows, setUserRows] = useState([]);
  const [updateUserRows, setUpdateUserRows] = useState([]);
  const [userColumns, setUserColumns] = useState([]);
  const [fileRows, setFileRows] = useState([]);
  const [originFileRows, setOriginFileRows] = useState([]);
  const [updateFileRows, setUpdateFileRows] = useState([]);
  const [fileColumns, setFileColumns] = useState([]);
  const [tabID, setTabID] = useState('1');
  const [inputs, setInputs] = useState({
    outgoing_id: null,
    outgoing_number: '',
    outgoing_date:'',
    outgoing_partner_id: 0,
    outgoing_partner_name: '',
    outgoing_partner_manager: '',
    outgoing_partner_manager_phone: '',
    outgoing_partner_manager_mail: '',
    outgoing_partner_delivery_post: '',
    outgoing_partner_delivery_address: '',
    outgoing_partner_delivery_address_add: '',
    outgoing_bigo: '',
    outgoing_order_id: null,
    outgoing_order_number: '',
    outgoing_ref_outgoing_id: null
  });
  const [selectmodalTitle, setSelectModalTitle] = useState('');
  const [isSelectOrderModalOpen, setSelectOrderModalOpen] = useState(false);
  const [isSelectOutgoingModalOpen, setSelectOutgoingModalOpen] = useState(false);
  const [isSelectPartnerModalOpen, setSelectPartnerModalOpen] = useState(false);
  const [isSelectItemModalOpen, setSelectItemModalOpen] = useState(false);
  const [isSelectUserModalOpen, setSelectUserModalOpen] = useState(false);
  const [selectItemData, setSelectItemData] = useState('');
  const [selectUserData, setSelectUserData] = useState('');
  const [selectLotData, setSelectLotData] = useState('');
  const [updateFlag, setUpdateFlag] = useState(MenuUpdateYN === 'Y' && originRows.some(row =>
    [row.outgoing_user_id, row.reg_user_id, row.update_user_id].includes(Number(localStorage.getItem('user_id')))
  ));
  
  const handleInitSelect = () => {
    const t0 = performance.now();

    // 초기화
    tmpRealFiles = [];
    setUpdateUserRows([]);
    setUpdateItemRows([]);
    setUpdateLotRows([]);
    setUpdateFileRows([]);

    const rows = originRows || [];
    const first = rows[0];
    if (!first) return;

    // 입력 세팅
    setInputs({
      outgoing_id: Number(first.outgoing_id),
      outgoing_number: first.outgoing_number,
      outgoing_date: first.outgoing_date,
      outgoing_partner_id: Number(first.outgoing_partner_id),
      outgoing_partner_name: first.outgoing_partner_name,
      outgoing_partner_manager: first.outgoing_partner_manager,
      outgoing_partner_manager_phone: first.outgoing_partner_manager_phone,
      outgoing_partner_manager_mail: first.outgoing_partner_manager_mail,
      outgoing_partner_delivery_post: first.outgoing_partner_delivery_post,
      outgoing_partner_delivery_address: first.outgoing_partner_delivery_address,
      outgoing_partner_delivery_address_add: first.outgoing_partner_delivery_address_add,
      outgoing_bigo: first.outgoing_bigo,
      outgoing_order_id: Number(first.outgoing_order_id),
      outgoing_order_number: first.outgoing_order_number,
      outgoing_ref_outgoing_id: Number(first.outgoing_ref_outgoing_id),
    });

    // 1패스 분류 + 중복제거(Map)
    const itemMap = new Map(); 
    const userMap = new Map(); 
    const fileMap = new Map(); 

    const itemIdToSeq = new Map(); 

    for (const r of rows) {
      if (r.outgoing_item_seq !== undefined && !itemMap.has(r.outgoing_item_seq)) {
        const spec = (
                      (r.outgoing_item_spec || '') +
                      appStore.ITEM_FULL_SPEC_MAKE(
                        r.outgoing_item_width,
                        r.outgoing_item_depth,
                        r.outgoing_item_height
                      )
                    ).trim();
        const item = {
          id: r.outgoing_item_seq,
          outgoing_item_id: r.outgoing_item_id,
          outgoing_item_name: r.outgoing_item_name,
          outgoing_item_spec: spec,
          outgoing_package_count: r.outgoing_package_count,
          outgoing_pack_rate: r.outgoing_pack_rate,
          outgoing_item_count: r.outgoing_item_count,
          outgoing_quality_exam_yn: r.outgoing_quality_exam_yn,
          outgoing_item_bigo: r.outgoing_item_bigo,
          row_type: 'O',
          update_type: 'N',
        };
        itemMap.set(r.outgoing_item_seq, item);
        itemIdToSeq.set(r.outgoing_item_id, r.outgoing_item_seq);
      }

      if (r.outgoing_user_seq !== undefined && !userMap.has(r.outgoing_user_seq)) {
        userMap.set(r.outgoing_user_seq, {
          id: r.outgoing_user_seq,
          outgoing_user_id: r.outgoing_user_id,
          outgoing_user_name: r.outgoing_user_name,
          outgoing_user_dept_name: r.outgoing_user_dept_name,
          outgoing_user_position_name: r.outgoing_user_position_name,
          outgoing_user_type: r.outgoing_user_type,
          outgoing_user_bigo: r.outgoing_user_bigo,
          row_type: 'O',
          update_type: 'N',
        });
      }

      if (r.outgoing_file_id !== undefined && !fileMap.has(r.outgoing_file_id)) {
        fileMap.set(r.outgoing_file_id, {
          id: r.outgoing_file_id,
          file_name_sever: r.outgoing_file_name_sever,
          file_size: r.outgoing_file_size,
          file_type: r.outgoing_file_type,
          file_extension: r.outgoing_file_extension,
          file_name: r.outgoing_file_name,
          file_type_name: r.outgoing_file_type_name,
          file_size_dp: r.outgoing_file_size_dp,
          reg_user_name: r.outgoing_file_user_name,
          reg_datetime: Moment(r.outgoing_file_user_datetime).format('YYYY-MM-DD HH:mm:ss'),
          row_type: 'O',
          update_type: 'N',
        });
      }
    }

    axios.get('/api/p/Outgoing/LotList',
        {
        params : {
          outgoing_id : id
        }
      },
      { withCredentials: true }
    )
    .then((response) => {
      if(response.data.length > 0){

        var LotData = (response.data).filter((item, index) => {
          return (
            (response.data).findIndex((item2, index2) => {
              return typeof item.lot_outgoing_item_lot_seq !== 'undefined' && item.lot_outgoing_item_lot_seq === item2.lot_outgoing_item_lot_seq;
            }) === index
          );
        });

        setLotRows(LotData.map((item, index) => ({
            id: item.lot_outgoing_item_lot_seq,
            upper_id: item.outgoing_item_seq,
            lot_no: item.lot_outgoing_item_lotno,
            lot_outgoing_item_id: item.lot_outgoing_item_id,
            lot_outgoing_item_name: item.lot_outgoing_item_name,
            lot_outgoing_item_spec: item.lot_outgoing_item_spec,
            lot_outgoing_quality_exam_yn: item.lot_outgoing_quality_exam_yn,
            lot_outgoing_save_workplace_id: item.lot_outgoing_save_workplace_id,
            lot_outgoing_save_workplace_name: item.lot_outgoing_save_workplace_name,
            lot_outgoing_save_warehouse_id: item.lot_outgoing_save_warehouse_id,
            lot_outgoing_save_warehouse_name: item.lot_outgoing_save_warehouse_name,
            lot_outgoing_save_section_id: item.lot_outgoing_save_section_id,
            lot_outgoing_save_section_name: item.lot_outgoing_save_section_name,
            row_type: 'O',
            update_type: 'N',
        })));

        setUpdateLotRows(LotData.map((item, index) => ({
            id: item.lot_outgoing_item_lot_seq,
            upper_id: item.outgoing_item_seq,
            lot_no: item.lot_outgoing_item_lotno,
            lot_outgoing_item_id: item.lot_outgoing_item_id,
            lot_outgoing_item_name: item.lot_outgoing_item_name,
            lot_outgoing_item_spec: item.lot_outgoing_item_spec,
            lot_outgoing_quality_exam_yn: item.lot_outgoing_quality_exam_yn,
            lot_outgoing_save_workplace_id: item.lot_outgoing_save_workplace_id,
            lot_outgoing_save_workplace_name: item.lot_outgoing_save_workplace_name,
            lot_outgoing_save_warehouse_id: item.lot_outgoing_save_warehouse_id,
            lot_outgoing_save_warehouse_name: item.lot_outgoing_save_warehouse_name,
            lot_outgoing_save_section_id: item.lot_outgoing_save_section_id,
            lot_outgoing_save_section_name: item.lot_outgoing_save_section_name,
            row_type: 'O',
            update_type: 'N',
        })));

        setOriginLotRows(LotData.map((item, index) => ({
            id: item.lot_outgoing_item_lot_seq,
            upper_id: item.outgoing_item_seq,
            lot_no: item.lot_outgoing_item_lotno,
            lot_outgoing_item_id: item.lot_outgoing_item_id,
            lot_outgoing_item_name: item.lot_outgoing_item_name,
            lot_outgoing_item_spec: item.lot_outgoing_item_spec,
            lot_outgoing_quality_exam_yn: item.lot_outgoing_quality_exam_yn,
            lot_outgoing_save_workplace_id: item.lot_outgoing_save_workplace_id,
            lot_outgoing_save_workplace_name: item.lot_outgoing_save_workplace_name,
            lot_outgoing_save_warehouse_id: item.lot_outgoing_save_warehouse_id,
            lot_outgoing_save_warehouse_name: item.lot_outgoing_save_warehouse_name,
            lot_outgoing_save_section_id: item.lot_outgoing_save_section_id,
            lot_outgoing_save_section_name: item.lot_outgoing_save_section_name,
            row_type: 'O',
            update_type: 'N',
        })));
      }
    })
    .catch((error) => {
        appStore.capture();
    });

    const t1 = performance.now();

    // 정렬
    const itemRows = Array.from(itemMap.values()).sort((a, b) => a.id - b.id);
    const userRows = Array.from(userMap.values()).sort((a, b) => a.id - b.id);
    const fileRows = Array.from(fileMap.values()).sort((a, b) => a.id - b.id);

    const t2 = performance.now();

    // setState
    setItemRows(itemRows);
    setOriginItemRows(itemRows);
    
    setUserRows(userRows);

    setFileRows(fileRows);
    setOriginFileRows(fileRows);

    // newFileID 갱신
    let maxFileId = typeof newFileID === 'number' ? newFileID : 0;
    for (const f of fileRows) if (typeof f.id === 'number' && f.id >= maxFileId) maxFileId = f.id + 1;
    newFileID = maxFileId;

    const t3 = performance.now();
  };

  const handleSetting = () => {
    setItemColumns([
      {
        field: 'actions',
        headerName: '동작',
        width: 55,
        type:'actions',
        disableClickEventBubbling: true,
        getActions: (params) => [
            ((params.row.update_type === "U")? 
            <GridActionsCellItem icon={<DeleteIcon color={ "error" } />} onClick={() => {itemDeleteClick(params)}} label="Delete" />
            : (params.row.row_type === "A" && params.row.update_type === "N")? 
            <GridActionsCellItem icon={<AddIcon color="secondary" />} onClick={() => {itemAddClick(params)}} label="Add"  /> 
            :<GridActionsCellItem icon={<DeleteIcon color={ "error" } />} onClick={() => {itemDeleteClick(params)}} label="Delete" />
            )
          ],
        headerAlign: 'center', 
        align:'center'
      },
      { field: 'id', headerName: 'id', width: 0, headerAlign: 'center' },
      { field: 'outgoing_item_id', headerName: 'outgoing_item_id', headerAlign: 'center', align:'center' },
      { field: 'outgoing_item_name', headerName: '품목', width: 180, headerAlign: 'center', align:'left' },
      { field: 'outgoing_item_spec', headerName: '규격', width: 180, headerAlign: 'center', align:'left' },
      { field: 'outgoing_package_count', headerName: '수량', type: 'number', width: 80, headerAlign: 'center', align:'right', editable: true },
      { field: 'outgoing_pack_rate', headerName: '포장수량', type: 'number', width: 80, headerAlign: 'center', align:'right', editable: true },
      { field: 'outgoing_item_count', headerName: '출하수량', type: 'number', width: 90, headerAlign: 'center', align:'right', editable: false },
      { field: 'outgoing_quality_exam_yn', headerName: '검사여부', type: 'singleSelect', width: 80, 
        valueOptions: () => qualityYnModalOption ?? [], valueFormmatter: ({  value }) => 
          qualityYnModalOption.find((opt) => String(opt.value) === String(value))?.label ?? '',
        editable: true, headerAlign: 'center', align:'center' },
      { field: 'outgoing_item_bigo', headerName: '비고', width: 230, headerAlign: 'center', align:'left', editable: true },
      { field: 'row_type', headerName: 'row_type', width: 0, headerAlign: 'center' },
      { field: 'update_type', headerName: 'update_type', width: 0, headerAlign: 'center' }
    ]);

    setLotColumns([
      { field: 'id', headerName: 'id', width: 0, headerAlign: 'center' },
      { field: 'upper_id', headerName: 'upper_id', width: 0, headerAlign: 'center' },
      { field: 'lot_no', headerName: 'LotNo', width: 165, headerAlign: 'center', align:'center' },
      { field: 'lot_outgoing_item_id', headerName: 'lot_outgoing_item_id', headerAlign: 'center', align:'center' },
      { field: 'lot_outgoing_item_name', headerName: '품목', width: 130, headerAlign: 'center', align:'left' },
      { field: 'lot_outgoing_item_spec', headerName: '규격', width: 185, headerAlign: 'center', align:'left' },
      { field: 'lot_outgoing_quality_exam_yn', headerName: '검사여부', type: 'singleSelect', width: 80, 
        valueOptions: () => qualityYnModalOption ?? [], valueFormmatter: ({  value }) => 
          qualityYnModalOption.find((opt) => String(opt.value) === String(value))?.label ?? '',
        editable: true, headerAlign: 'center', align:'center' },
      { field: 'lot_outgoing_save_workplace_id', headerName: 'lot_outgoing_save_workplace_id',width: 0, headerAlign: 'center'},
      { field: 'lot_outgoing_save_workplace_name', headerName: '사업장',width: 110, headerAlign: 'center'},
      { field: 'lot_outgoing_save_warehouse_id', headerName: 'lot_outgoing_save_warehouse_id', width: 0, headerAlign: 'center' },
      { field: 'lot_outgoing_save_warehouse_name', headerName: '창고', width: 110, headerAlign: 'center', align:'left' },
      { field: 'lot_outgoing_save_section_id', headerName: 'lot_outgoing_save_section_id',width: 0, headerAlign: 'center'},
      { field: 'lot_outgoing_save_section_name', headerName: '구역',width: 110, headerAlign: 'center', align:'left'},
      { field: 'row_type', headerName: 'row_type', width: 0, headerAlign: 'center' },
      { field: 'update_type', headerName: 'update_type', width: 0, headerAlign: 'center' },
    ]);

    setUserColumns([
      {
        field: 'actions',
        headerName: '동작',
        width: 55,
        type:'actions',
        disableClickEventBubbling: true,
        getActions: (params) => [
            ((params.row.update_type === "U")? 
            <GridActionsCellItem icon={<DeleteIcon color={ "error" } />} onClick={() => {userDeleteClick(params)}} label="Delete" />
            : (params.row.row_type === "A" && params.row.update_type === "N")? 
            <GridActionsCellItem icon={<AddIcon color="secondary" />} onClick={() => {userAddClick(params)}} label="Add"  /> 
            :<GridActionsCellItem icon={<DeleteIcon color={ "error" } />} onClick={() => {userDeleteClick(params)}} label="Delete" />
            )
          ],
        headerAlign: 'center', 
        align:'center'
      },
      { field: 'id', headerName: 'id', width: 0, headerAlign: 'center' },
      { field: 'outgoing_user_id', headerName: 'outgoing_user_id', width: 0, headerAlign: 'center' },
      { field: 'outgoing_user_name', headerName: '담당자명', width: 120, headerAlign: 'center', align:'center' },
      { field: 'outgoing_user_dept_name', headerName: '담당자부서', width: 120, headerAlign: 'center', align:'center' },
      { field: 'outgoing_user_position_name', headerName: '담당자직위', width: 120, headerAlign: 'center', align:'center' },
      { field: 'outgoing_user_type', headerName: '담당자유형', type: 'singleSelect', width: 120, 
        valueOptions: () => userTypeModalOption ?? [], valueFormmatter: ({  value }) => 
        userTypeModalOption.find((opt) => String(opt.value) === String(value))?.label ?? '',
        editable: true, headerAlign: 'center', align:'center' },
      { field: 'outgoing_user_bigo', headerName: '비고', width: 350, headerAlign: 'center', align:'left', editable: true },
      { field: 'row_type', headerName: 'row_type', width: 0, headerAlign: 'center' },
      { field: 'update_type', headerName: 'update_type', width: 0, headerAlign: 'center' },
    ]);

    setFileColumns([
      {
        field: 'actions',
        headerName: '동작',
        width: 55,
        type:'actions',
        disableClickEventBubbling: true,
        getActions: (params) => [
            ((params.row.update_type === "U")? 
            <GridActionsCellItem icon={<DeleteIcon color={ "error" } />} onClick={() => {fileDeleteClick(params)}} label="Delete" />
            : (params.row.row_type === "A" && params.row.update_type === "N")? 
            <GridActionsCellItem icon={<AddIcon color="secondary" />} onClick={() => {fileAddClick(params)}} label="Add"  /> 
            :<GridActionsCellItem icon={<DeleteIcon color={ "error" } />} onClick={() => {fileDeleteClick(params)}} label="Delete" />
            )
          ],
        headerAlign: 'center', 
        align:'center'
      },
      {
        field: 'download',
        headerName: '다운로드',
        width: 90,
        type:'actions',
        disableClickEventBubbling: true,
        getActions: (params) => [
            ((params.row.row_type === "O")?
            <GridActionsCellItem icon={<DownloadIcon color={ "primary" } />} onClick={() => {fileDownloadClick(params)}} label="Download" />:<></>)
        ],
        headerAlign: 'center', 
        align:'center'
      },
      { field: 'id', headerName: 'id', width: 0, headerAlign: 'center' },
      { field: 'file_name_sever', headerName: 'file_name_sever', width: 0, headerAlign: 'center' },
      { field: 'file_size', headerName: 'file_size', width: 0, headerAlign: 'center' },
      { field: 'file_type', headerName: 'file_type', width: 0, headerAlign: 'center' },
      { field: 'file_extension', headerName: 'file_extension', width: 0, headerAlign: 'center' },
      { field: 'file_name', headerName: '파일명', width: 270, headerAlign: 'center' },
      { field: 'file_type_name', headerName: '유형', width: 110, headerAlign: 'center', align:'center' },
      { field: 'file_size_dp', headerName: '크기', width: 100, headerAlign: 'center', align:'right' },
      { field: 'reg_user_name', headerName: '등록자', width: 90, headerAlign: 'center', align:'center' },
      { field: 'reg_datetime', headerName: '등록일시', width: 160, headerAlign: 'center', align:'center' },
      { field: 'row_type', headerName: 'row_type', width: 0, headerAlign: 'center' },
      { field: 'update_type', headerName: 'update_type', width: 0, headerAlign: 'center' },
    ]);

    setItemColumnVisibilityModel({
      id: false,
      actions: updateFlag,
      outgoing_item_id: false,
      outgoing_item_name: true,
      outgoing_item_spec: false,
      outgoing_package_count: true,
      outgoing_pack_rate: true,
      outgoing_item_count: true,
      outgoing_quality_exam_yn: false,
      outgoing_item_bigo: true,
      row_type: false,
      update_type: false
    });

    setLotColumnVisibilityModel({
      id: false,
      upper_id: false,
      lot_no: true,
      lot_outgoing_item_id: false,
      lot_outgoing_item_name: true,
      lot_outgoing_item_spec: false,
      lot_outgoing_quality_exam_yn: false,
      lot_outgoing_save_workplace_id: false,
      lot_outgoing_save_workplace_name: true,
      lot_outgoing_save_warehouse_id: false,
      lot_outgoing_save_warehouse_name: true,
      lot_outgoing_save_section_id: false,
      lot_outgoing_save_section_name: true,
      row_type: false,
      update_type: false
    });

    setUserColumnVisibilityModel({
      id: false,
      actions: updateFlag,
      outgoing_user_id: false,
      outgoing_user_name: true,
      outgoing_user_dept_name: true,
      outgoing_user_position_name: true,
      outgoing_user_type: true,
      outgoing_user_bigo: true,
      row_type: false,
      update_type: false
    });

    setFileColumnVisibilityModel({
      id: false,
      file_name_sever: false,
      file_size: false,
      file_type: false,
      file_extension: false,
      file_name: true,
      file_type_name: true,
      file_size_dp: true,
      reg_user_name: true,
      reg_datetime: true,
      actions: updateFlag,
      download: true,
      row_type: false,
      update_type: false
    });
  }

  const [itemColumnVisibilityModel, setItemColumnVisibilityModel] = useState({
    id: false,
    actions: updateFlag,
    outgoing_item_id: false,
    outgoing_item_name: true,
    outgoing_item_spec: false,
    outgoing_package_count: true,
    outgoing_pack_rate: true,
    outgoing_item_count: true,
    outgoing_quality_exam_yn: true,
    outgoing_item_bigo: false,
    row_type: false,
    update_type: false
  });

  const [lotColumnVisibilityModel, setLotColumnVisibilityModel] = useState({
    id: false,
    upper_id: false,
    lot_no: true,
    lot_outgoing_item_id: false,
    lot_outgoing_item_name: true,
    lot_outgoing_item_spec: false,
    lot_outgoing_quality_exam_yn: true,
    lot_outgoing_save_workplace_id: false,
    lot_outgoing_save_workplace_name: true,
    lot_outgoing_save_warehouse_id: false,
    lot_outgoing_save_warehouse_name: true,
    lot_outgoing_save_section_id: false,
    lot_outgoing_save_section_name: true,
    row_type: false,
    update_type: false
  });

  const [userColumnVisibilityModel, setUserColumnVisibilityModel] = useState({
    id: false,
    actions: updateFlag,
    outgoing_user_id: false,
    outgoing_user_name: true,
    outgoing_user_dept_name: true,
    outgoing_user_position_name: true,
    outgoing_user_type: true,
    outgoing_user_bigo: true,
    row_type: false,
    update_type: false
  });

  const [fileColumnVisibilityModel, setFileColumnVisibilityModel] = useState({
    id: false,
    file_name_sever: false,
    file_size: false,
    file_type: false,
    file_extension: false,
    file_name: true,
    file_type_name: true,
    file_size_dp: true,
    reg_user_name: true,
    reg_datetime: true,
    actions: updateFlag,
    download: true,
    row_type: false,
    update_type: false
  });

  useEffect(() => {
    //렌더링 될 때 마다 실행된다.
  });

  useEffect(() => {
    // Mount 될때만 실행된다.
    realFiles = [];
    tmpRealFiles = [];
    handleSetting();
    handleInitSelect();
    setTabPanelHeight(tabPanelRef.current.clientHeight);
  }, []);

  // 🚨 updateFlag 갱신 시 동작(삭제/추가) 컬럼 표시 갱신 (첫 레코드 기준 고정 방지)
  useEffect(() => {
    setItemColumnVisibilityModel((m) => ({ ...m, actions: updateFlag }));
    setUserColumnVisibilityModel((m) => ({ ...m, actions: updateFlag }));
    setFileColumnVisibilityModel((m) => ({ ...m, actions: updateFlag }));
  }, [updateFlag]);


  useEffect(() => {
    handleInitSelect();
  }, [originRows]);

  useEffect(() => {
    let ADD_YN= 'Y'
    for(let i=0; i<itemRows.length; i++){
      if(itemRows[i].row_type === 'A' && itemRows[i].update_type === 'N'){
        ADD_YN = "N";
      }
    }

    if(ADD_YN === 'Y' && updateFlag){
      setItemRows((itemRows) => [...itemRows, { 
        id: Number(appStore.getMaxListID(itemRows))+1,
        outgoing_item_id: '',
        outgoing_item_name: '',
        outgoing_item_spec: '',
        outgoing_package_count: '',
        outgoing_pack_rate: '',
        outgoing_item_count: '',
        outgoing_quality_exam_yn: 'N',
        outgoing_item_bigo: '',
        row_type:'A',
        update_type: 'N'
      }]);
    }
  }, [itemRows, updateFlag]);
  
  useEffect(() => {
    // userRows가 변경될 때 마지막 Row ADD가 없으면 추가시킨다.
    let ADD_YN= 'Y'
    for(let i=0; i<userRows.length; i++){
      if(userRows[i].row_type === 'A' && userRows[i].update_type === 'N'){
        ADD_YN = "N"; 
      }
    }

    if(ADD_YN === 'Y' && updateFlag){
      setUserRows((userRows) => [...userRows, { 
        id: Number(appStore.getMaxListID(userRows))+1,
        outgoing_user_id: '',
        outgoing_user_name: '',
        outgoing_user_dept_name: '',
        outgoing_user_position_name: '',
        outgoing_user_type: '',
        outgoing_user_bigo: '',
        row_type:'A',
        update_type: 'N'
      }]);
    }
  }, [userRows, updateFlag]);

  useEffect(() => {
    let ADD_YN= 'Y'
    var array = [];
    for(var i=0; i<fileRows.length; i++){
      var tmp_id = fileRows[i].id;
      var tmp_file_name_sever = fileRows[i].file_name_sever;
      var tmp_file_size = fileRows[i].file_size;
      var tmp_file_type = fileRows[i].file_type;
      var tmp_file_extension = fileRows[i].file_extension;
      var tmp_file_name = fileRows[i].file_name;
      var tmp_file_type_name = fileRows[i].file_type_name;
      var tmp_file_size_dp = fileRows[i].file_size_dp;
      var tmp_reg_user_name = fileRows[i].reg_user_name;
      var tmp_reg_datetime = fileRows[i].reg_datetime;
      var tmp_row_type = fileRows[i].row_type;
      var tmp_update_type = fileRows[i].update_type;
      
      if(tmp_row_type !== 'A' || tmp_update_type !== 'N'){
        array.push({
          id: newFileID,
          file_name_sever: tmp_file_name_sever,
          file_size: tmp_file_size,
          file_type: tmp_file_type,
          file_extension: tmp_file_extension,
          file_name: tmp_file_name,
          file_type_name: tmp_file_type_name,
          file_size_dp: tmp_file_size_dp,
          reg_user_name: tmp_reg_user_name,
          reg_datetime: tmp_reg_datetime,
          row_type:tmp_row_type,
          update_type: tmp_update_type
        })
        newFileID = newFileID + 1;
      }
    }
    setUpdateFileRows(array);
    
    for(let i=0; i<fileRows.length; i++){
      if(fileRows[i].row_type === 'A' && fileRows[i].update_type === 'N'){
        ADD_YN = "N";
      }
    }
    
    if(ADD_YN === 'Y' && updateFlag){
      setFileRows((fileRows) => [...fileRows, { 
        id: Number(appStore.getMaxListID(fileRows))+1,
        file_name_sever: '',
        file_size: 0,
        file_type: '',
        file_extension: '',
        file_name: '',
        file_type_name: '',
        file_size_dp: '',
        reg_user_name: '',
        reg_datetime: '',
        row_type:'A',
        update_type: 'N'
      }]);
    }
  }, [fileRows, updateFlag]);

  const onClick = (e)=>{ 
    setSelectModalTitle('출하처 목록')
    setSelectPartnerModalOpen(true);
  };

  const onChange = (e)=>{
    const {name, value} = e.target;
    const nextInputs = {
        ...inputs,
        [name]: value, 
    };
    setInputs(nextInputs);
  };

  const onDateChange = (e)=>{
    const {name, value} = e.target;
    const nextInputs = {
        ...inputs,
        [name]: value, 
    };
    setInputs(nextInputs);
  };

  const onHypenChange = (e)=>{
    const {name, value} = e.target;
    var hyphen_data = ''
    if(e.target.name === 'outgoing_partner_manager_phone'){ // 전화번호인 경우
        hyphen_data = e.target.value
        .replace(/[^0-9.]/g, "")
        .replace(/^(\d{0,3})(\d{0,4})(\d{0,4})$/g, "$1-$2-$3")
        .replace(/(-{1,2})$/g, "");
    }
    const nextInputs = {
        ...inputs,
        [name]: hyphen_data, 
    };
    setInputs(nextInputs);
  };

  const handleTabID = (event, newTabID) => {
    setTabID(newTabID);
  };

  const processItemRowUpdate = (newRow, oldRow) => {
    if(newRow.outgoing_package_count > 99999 || newRow.outgoing_pack_rate > 99999){
      return;
    }

    let newUpdateDataArray = {}
    const newNoDataArray = { 
        ...newRow
        , update_type: 'N' }; 
    
    if(newRow.outgoing_item_id !== oldRow.outgoing_item_id || newRow.outgoing_item_name !== oldRow.outgoing_item_name 
      || newRow.outgoing_package_count !== oldRow.outgoing_package_count || newRow.outgoing_pack_rate !== oldRow.outgoing_pack_rate
      || newRow.outgoing_quality_exam_yn !== oldRow.outgoing_quality_exam_yn || newRow.outgoing_item_bigo !== oldRow.outgoing_item_bigo){
      
      // ▼ 수량 혹은 포장이 변경된 경우 총수량 재계산
      if (newRow.outgoing_package_count !== oldRow.outgoing_package_count || newRow.outgoing_pack_rate !== oldRow.outgoing_pack_rate){
        const pkgCount = Number(newRow.outgoing_package_count || 0);
        const packRate = Number(newRow.outgoing_pack_rate || 1);
        newUpdateDataArray = { 
          ...newRow
          , ['outgoing_item_count']: pkgCount * packRate
          , update_type: 'U' }; 
      } else {
        newUpdateDataArray = { ...newRow, update_type: 'U' }; 
      }

      var row_outgoing_item_id = '';
      var row_outgoing_item_name = '';
      var row_outgoing_item_spec = '';
      var row_outgoing_package_count = '';
      var row_outgoing_pack_rate = '';
      var row_outgoing_item_count = '';
      var row_outgoing_quality_exam_yn = 'N';
      var row_outgoing_item_bigo = '';
      
      if(String(newRow.row_type) === "A"){
        if(newRow.outgoing_item_id !== '' || newRow.outgoing_item_name !== '' || newRow.outgoing_item_spec !== '' || newRow.outgoing_package_count !== '' || newRow.outgoing_pack_rate !== '' || newRow.outgoing_item_bigo !== '' || newRow.outgoing_quality_exam_yn !== 'N'){
          row_outgoing_item_id = newRow.outgoing_item_id;
          row_outgoing_item_name = newRow.outgoing_item_name;
          row_outgoing_item_spec = newRow.outgoing_item_spec;
          row_outgoing_package_count = newRow.outgoing_package_count;
          row_outgoing_pack_rate = newRow.outgoing_pack_rate;
          row_outgoing_item_count = newRow.outgoing_item_count;
          row_outgoing_quality_exam_yn = newRow.outgoing_quality_exam_yn;
          row_outgoing_item_bigo = newRow.outgoing_item_bigo;
        }
      }else{
        itemRows.map((data) => data.id === newRow.id 
          && (data.outgoing_item_id !== newRow.outgoing_item_id || data.outgoing_item_name !== newRow.outgoing_item_name || data.outgoing_item_spec !== newRow.outgoing_item_spec || data.outgoing_package_count !== newRow.outgoing_package_count || data.outgoing_pack_rate !== newRow.outgoing_pack_rate || data.outgoing_quality_exam_yn !== newRow.outgoing_quality_exam_yn || data.outgoing_item_bigo !== newRow.outgoing_item_bigo)?
          (
            row_outgoing_item_id = data.outgoing_item_id,
            row_outgoing_item_name = data.outgoing_item_name,
            row_outgoing_item_spec = data.outgoing_item_spec,
            row_outgoing_package_count = data.outgoing_package_count,
            row_outgoing_pack_rate = data.outgoing_pack_rate,
            row_outgoing_item_count = data.outgoing_item_count,
            row_outgoing_quality_exam_yn = data.outgoing_quality_exam_yn,
            row_outgoing_item_bigo = data.outgoing_item_bigo
          ):""
        )
      }
      
      if(row_outgoing_item_id === '' && row_outgoing_item_name === '' && row_outgoing_item_spec === '' && row_outgoing_package_count === '' && row_outgoing_pack_rate === '' && row_outgoing_quality_exam_yn === 'N' && row_outgoing_item_bigo === ''){
        if(updateItemRows.length > 0){
          setUpdateItemRows(updateItemRows.filter((data) => data.id !== newRow.id));
          setItemRows(itemRows.map((data) => data.id === newRow.id? newNoDataArray : data ));
          searchLotRow(newNoDataArray, 'O');
        }
        return newNoDataArray;
      }else{
        var updateRowsYN = 'N'; 
        for (let i = 0; i < updateItemRows.length; i++) {
          if(updateItemRows[i].id === newRow.id){
            updateRowsYN = 'Y';
          }
        }
        
        if(updateRowsYN === 'Y'){
          setUpdateItemRows(updateItemRows.map((data) => data.id === newRow.id? newUpdateDataArray : data ));
          setItemRows(itemRows.map((data) => data.id === newRow.id? newUpdateDataArray : data ));
          searchLotRow(newUpdateDataArray, 'A');
        }else{
          setUpdateItemRows(prevRows => [...prevRows, newUpdateDataArray]);
          setItemRows(itemRows.map((data) => data.id === newRow.id? newUpdateDataArray : data ));
          searchLotRow(newUpdateDataArray, 'A');
        }
        return newUpdateDataArray;
      }
    }
    return { ...newRow };
  };

  const searchLotRow = async (tempNewUpdateData, tempType, startCount = 0) => { 
    if(tempNewUpdateData.outgoing_item_count === null || tempNewUpdateData.outgoing_item_count === ''){
      tempNewUpdateData.outgoing_item_count = 0
      tempType = 'D'
    }

    if(tempType === 'D'){ 
      setLotRows((lotRows) => lotRows.filter((data) => data.upper_id !== tempNewUpdateData.id));
      setUpdateLotRows((updateLotRows) => updateLotRows.filter((data) => data.upper_id !== tempNewUpdateData.id));

    } else if(tempType === 'O'){ 
      setLotRows((lotRows) => lotRows.filter((data) => data.upper_id !== tempNewUpdateData.id));
      setUpdateLotRows((updateLotRows) => updateLotRows.filter((data) => data.upper_id !== tempNewUpdateData.id));

    } else if(tempType === 'A'){ 
      if(typeof itemRows.find((data) => data.id === tempNewUpdateData.id) !== 'undefined' && (tempNewUpdateData.outgoing_item_count === 0 || tempNewUpdateData.outgoing_item_count === '' || tempNewUpdateData.outgoing_item_count === null)){
      }else if(tempNewUpdateData.outgoing_item_count < 0){
        Swal.fire({
          title: '<p style="color:red">출하 수량 오류</p>',
          text: '출하 수량은 음수가 될 수 없습니다.',
          confirmButtonText: '확인'
        });

        processItemRowUpdate(
          {
            id: tempNewUpdateData.id,
            outgoing_item_id: tempNewUpdateData.outgoing_item_id,
            outgoing_item_name: tempNewUpdateData.outgoing_item_name,
            outgoing_item_spec: tempNewUpdateData.outgoing_item_spec,
            outgoing_package_count: tempNewUpdateData.outgoing_package_count,
            outgoing_pack_rate: tempNewUpdateData.outgoing_pack_rate,
            outgoing_item_count: '',
            outgoing_quality_exam_yn: tempNewUpdateData.outgoing_quality_exam_yn,
            outgoing_item_bigo: tempNewUpdateData.outgoing_item_bigo,
            row_type:tempNewUpdateData.row_type,
            update_type: tempNewUpdateData.update_type,
          },
          {
            id: tempNewUpdateData.id,
            outgoing_item_id: tempNewUpdateData.outgoing_item_id,
            outgoing_item_name: tempNewUpdateData.outgoing_item_name,
            outgoing_item_spec: tempNewUpdateData.outgoing_item_spec,
            outgoing_package_count: tempNewUpdateData.outgoing_package_count,
            outgoing_pack_rate: tempNewUpdateData.outgoing_pack_rate,
            outgoing_item_count: tempNewUpdateData.outgoing_item_count,
            outgoing_quality_exam_yn: tempNewUpdateData.outgoing_quality_exam_yn,
            outgoing_item_bigo: tempNewUpdateData.outgoing_item_bigo,
            row_type:tempNewUpdateData.row_type,
            update_type: tempNewUpdateData.update_type,
          }
        )
        return false;
      }else{
        if(tempNewUpdateData.outgoing_item_id == '' || tempNewUpdateData.outgoing_item_count == '' || tempNewUpdateData.outgoing_item_count == '0'){
          return;
        }

        setLotRows((lotRows) => lotRows.filter((data) => data.upper_id !== tempNewUpdateData.id));
        setUpdateLotRows((lotRows) => lotRows.filter((data) => data.upper_id !== tempNewUpdateData.id));
        
        return axios.get('/api/Common/StockFIFOInfo',
            {
            params : {
                item_id : tempNewUpdateData.outgoing_item_id,
                item_count: tempNewUpdateData.outgoing_item_count
            }
          },
          { withCredentials: true })
        .then((response) => {
          var start_lot_id = Number(appStore.getMaxListID(lotRows))+1+startCount;
          var create_lot_array = [];
          var lot_array = response.data;
          
          if(lot_array.length >= Number(tempNewUpdateData.outgoing_item_count)){
            for(var i=0; i<Number(tempNewUpdateData.outgoing_item_count); i++){
              create_lot_array.push(
                {
                  id: (start_lot_id+i),
                  upper_id :tempNewUpdateData.id,
                  lot_no: lot_array[i].item_lotno,
                  lot_outgoing_item_id : tempNewUpdateData.outgoing_item_id,
                  lot_outgoing_item_name: tempNewUpdateData.outgoing_item_name,
                  lot_outgoing_item_spec: tempNewUpdateData.outgoing_item_spec,
                  lot_outgoing_quality_exam_yn: tempNewUpdateData.outgoing_quality_exam_yn,
                  lot_outgoing_save_workplace_id: (typeof lot_array[i].item_lot_save_workplace_id === 'undefined'?null:lot_array[i].item_lot_save_workplace_id),
                  lot_outgoing_save_workplace_name: (typeof lot_array[i].item_lot_save_workplace_name === 'undefined'?null:lot_array[i].item_lot_save_workplace_name),
                  lot_outgoing_save_warehouse_id: (typeof lot_array[i].item_lot_save_warehouse_id === 'undefined'?null:lot_array[i].item_lot_save_warehouse_id),
                  lot_outgoing_save_warehouse_name: (typeof lot_array[i].item_lot_save_warehouse_name === 'undefined'?null:lot_array[i].item_lot_save_warehouse_name),
                  lot_outgoing_save_section_id: (typeof lot_array[i].item_lot_save_section_id === 'undefined'?null:lot_array[i].item_lot_save_section_id),
                  lot_outgoing_save_section_name: (typeof lot_array[i].item_lot_save_section_name === 'undefined'?null:lot_array[i].item_lot_save_section_name),
                  row_type: 'A',
                  update_type: 'U'
                }
              )
            }
            setLotRows((lotRows) => [...lotRows, ...create_lot_array ]);
            setUpdateLotRows((updateLotRows) => [...updateLotRows, ...create_lot_array ]);
            return true;
          }else{
            Swal.fire({
              title: '<p style="color:red">출하 품목 재고 부족</p>',
              text: '품목의 가용 재고가 ' + (String(lot_array.length)).replace(/\B(?=(\d{3})+(?!\d))/g, ",") + ' 입니다.',
              confirmButtonText: '확인'
            });
            
            processItemRowUpdate(
              {
                id: tempNewUpdateData.id,
                outgoing_item_id: tempNewUpdateData.outgoing_item_id,
                outgoing_item_name: tempNewUpdateData.outgoing_item_name,
                outgoing_item_spec: tempNewUpdateData.outgoing_item_spec,
                outgoing_package_count: tempNewUpdateData.outgoing_package_count,
                outgoing_pack_rate: tempNewUpdateData.outgoing_pack_rate,
                outgoing_item_count: '',
                outgoing_quality_exam_yn: tempNewUpdateData.outgoing_quality_exam_yn,
                outgoing_item_bigo: tempNewUpdateData.outgoing_item_bigo,
                row_type:tempNewUpdateData.row_type,
                update_type: tempNewUpdateData.update_type,
              },
              {
                id: tempNewUpdateData.id,
                outgoing_item_id: tempNewUpdateData.outgoing_item_id,
                outgoing_item_name: tempNewUpdateData.outgoing_item_name,
                outgoing_item_spec: tempNewUpdateData.outgoing_item_spec,
                outgoing_package_count: tempNewUpdateData.outgoing_package_count,
                outgoing_pack_rate: tempNewUpdateData.outgoing_pack_rate,
                outgoing_item_count: tempNewUpdateData.outgoing_item_count,
                outgoing_quality_exam_yn: tempNewUpdateData.outgoing_quality_exam_yn,
                outgoing_item_bigo: tempNewUpdateData.outgoing_item_bigo,
                row_type:tempNewUpdateData.row_type,
                update_type: tempNewUpdateData.update_type,
              }
            )
            return false;
          }
        });
      }
    }
    return true;
  };

  const processLotRowUpdate = (newRow, oldRow) => {
    const newUpdateDataArray = { 
        ...newRow
        , update_type: 'U' }; 
    const newNoDataArray = { 
        ...newRow
        , update_type: 'N' }; 
    
    if(newRow.lot_no !== oldRow.lot_no && newRow.lot_outgoing_item_id !== oldRow.lot_outgoing_item_id && newRow.lot_outgoing_quality_exam_yn !== oldRow.lot_outgoing_quality_exam_yn){
      var row_lot_no = '';
      var row_lot_outgoing_quality_exam_yn = 'N';
      
      if(String(newRow.row_type) === "A"){
        if(newRow.lot_no !== oldRow.lot_no || newRow.lot_outgoing_quality_exam_yn !== oldRow.lot_outgoing_quality_exam_yn){
          row_lot_no = newRow.lot_no;
          row_lot_outgoing_quality_exam_yn = newRow.lot_outgoing_quality_exam_yn;
        }
      }else{
        lotRows.map((data) => data.id === newRow.id 
          && (data.lot_no !== newRow.lot_no || data.lot_outgoing_quality_exam_yn !== newRow.lot_outgoing_quality_exam_yn)?
          (
            row_lot_no = data.lot_no,
            row_lot_outgoing_quality_exam_yn = data.row_lot_outgoing_quality_exam_yn
          ):""
        )
      }
      
      if(row_lot_no === '' && row_lot_outgoing_quality_exam_yn === 'N'){
        if(updateLotRows.length > 0){
          setUpdateLotRows(updateLotRows.filter((data) => data.id !== newRow.id));
          setLotRows(lotRows.map((data) => data.id === newRow.id? newNoDataArray : data ));
        }
        return newNoDataArray;
      }else{
        var updateRowsYN = 'N'; 
        for (let i = 0; i < updateLotRows.length; i++) {
          if(updateLotRows[i].id === newRow.id){
            updateRowsYN = 'Y';
          }
        }

        if(updateRowsYN === 'Y'){
          setUpdateLotRows(updateLotRows.map((data) => data.id === newRow.id? newUpdateDataArray : data ));
          setLotRows(lotRows.map((data) => data.id === newRow.id? newUpdateDataArray : data ));
        }else{
          setUpdateLotRows(prevRows => [...prevRows, newUpdateDataArray]);
          setLotRows(lotRows.map((data) => data.id === newRow.id? newUpdateDataArray : data ));
        }
        return newUpdateDataArray;
      }
    }
    return { ...newRow };
  };

  const processUserRowUpdate = (newRow, oldRow) => {
    const newUpdateDataArray = { ...newRow, update_type: 'U' }; 
    const newNoDataArray = { ...newRow, update_type: 'N' }; 
    
    if(oldRow.outgoing_user_id !== newRow.outgoing_user_id || oldRow.outgoing_user_type !== newRow.outgoing_user_type || oldRow.outgoing_user_bigo !== newRow.outgoing_user_bigo){
      var row_outgoing_user_id = '';
      var row_outgoing_user_name = '';
      var row_outgoing_user_type = '';
      var row_outgoing_user_bigo = '';
      
      if(String(newRow.row_type) === "A"){
        if(newRow.outgoing_user_id !== '' || newRow.outgoing_user_name !== '' || (newRow.outgoing_user_type !== '' && newRow.outgoing_user_type !== null) || newRow.outgoing_user_bigo !== '' ){
          row_outgoing_user_id = newRow.outgoing_user_id;
          row_outgoing_user_name = newRow.outgoing_user_name;
          row_outgoing_user_type = newRow.outgoing_user_type;
          row_outgoing_user_bigo = newRow.outgoing_user_bigo;
        }
      }else{
        userRows.map((data) => data.id === newRow.id 
          && (data.outgoing_user_id !== newRow.outgoing_user_id || data.outgoing_user_name !== newRow.outgoing_user_name || data.outgoing_user_type !== newRow.outgoing_user_type || data.outgoing_user_bigo !== newRow.outgoing_user_bigo )?
          (
            row_outgoing_user_id = data.outgoing_user_id,
            row_outgoing_user_name = data.outgoing_user_name,
            row_outgoing_user_type = data.outgoing_user_type,
            row_outgoing_user_bigo = data.outgoing_user_bigo
          ):""
        )
      }
      
      if(row_outgoing_user_id === '' && row_outgoing_user_name === '' && row_outgoing_user_bigo === '' && (row_outgoing_user_type === '' || row_outgoing_user_type === null)){
        if(updateUserRows.length > 0){
          setUpdateUserRows(updateUserRows.filter((data) => data.id !== newRow.id));
          setUserRows(userRows.map((data) => data.id === newRow.id? newNoDataArray : data ));
        }
        return newNoDataArray;
      }else{
        var updateRowsYN = 'N'; 
        for (let i = 0; i < updateUserRows.length; i++) {
          if(updateUserRows[i].id === newRow.id){
            updateRowsYN = 'Y';
          }
        }

        if(updateRowsYN === 'Y'){
          setUpdateUserRows(updateUserRows.map((data) => data.id === newRow.id? newUpdateDataArray : data ));
          setUserRows(userRows.map((data) => data.id === newRow.id? newUpdateDataArray : data ));
        }else{
          setUpdateUserRows(prevRows => [...prevRows, newUpdateDataArray]);
          setUserRows(userRows.map((data) => data.id === newRow.id? newUpdateDataArray : data ));
        }
        return newUpdateDataArray;
      }
    }
    return { ...newRow };
  };

  const itemAddClick = (object) => {
    if(object.row.row_type !== 'A' || object.row.update_type !== 'N'){
      setItemRows((itemRows) => [...itemRows, { 
        id: Number(appStore.getMaxListID(itemRows))+1,
        outgoing_item_id: '',
        outgoing_item_name: '',
        outgoing_item_spec: '',
        outgoing_package_count: '',
        outgoing_pack_rate: '',
        outgoing_item_count: '',
        outgoing_quality_exam_yn: 'N',
        outgoing_item_bigo: '',
        row_type:'A',
        update_type: 'N'
      }]);
    }else{
      setSelectModalTitle('품목 목록')
      setSelectItemModalOpen(true);
      setSelectItemData({
        id: object.row.id,
        outgoing_item_id: object.row.outgoing_item_id,
        outgoing_item_name: object.row.outgoing_item_name,
        outgoing_item_spec: object.row.outgoing_item_spec,
        outgoing_package_count: object.row.outgoing_package_count,
        outgoing_pack_rate: object.row.outgoing_pack_rate,
        outgoing_item_count: object.row.outgoing_item_count,
        outgoing_quality_exam_yn: object.row.outgoing_quality_exam_yn,
        outgoing_item_bigo: object.row.outgoing_item_bigo,
        row_type: object.row.row_type,
        update_type: object.row.update_type,
      })
    }
  };

  const itemDeleteClick = (object) => {
    if(object.row.row_type === 'O'){
      setUpdateItemRows(prevRows => [...prevRows, {
        id: object.row.id,
        outgoing_item_id: object.row.outgoing_item_id,
        outgoing_item_name: object.row.outgoing_item_name,
        outgoing_item_spec: object.row.outgoing_item_spec,
        outgoing_package_count: object.row.outgoing_package_count,
        outgoing_pack_rate: object.row.outgoing_pack_rate,
        outgoing_item_count: object.row.outgoing_item_count,
        outgoing_quality_exam_yn: object.row.outgoing_quality_exam_yn,
        outgoing_item_bigo: object.row.outgoing_item_bigo,
        row_type:'O',
        update_type: 'D'
      }]);
    }else{
      setUpdateItemRows((updateItemRows) => updateItemRows.filter((data) => data.id !== object.row.id));
    }
    setItemRows((itemRows) => itemRows.filter((data) => data.id !== object.row.id));
    searchLotRow(object.row, 'D')
  };

  const userAddClick = (object) => {
    if(object.row.row_type !== 'A' || object.row.update_type !== 'N'){
      setUserRows((userRows) => [...userRows, { 
        id: Number(appStore.getMaxListID(userRows))+1,
        outgoing_user_id: '',
        outgoing_user_name: '',
        outgoing_user_dept_name: '',
        outgoing_user_position_name: '',
        outgoing_user_type: '',
        outgoing_user_bigo: '',
        row_type:'A',
        update_type: 'N'
      }]);
    }else{
      setSelectModalTitle('사용자 목록')
      setSelectUserModalOpen(true);
      setSelectUserData({
        id: object.row.id,
        outgoing_user_id: object.row.outgoing_user_id,
        outgoing_user_name: object.row.outgoing_user_name,
        outgoing_user_dept_name: object.row.outgoing_user_dept_name,
        outgoing_user_position_name: object.row.outgoing_user_position_name,
        outgoing_user_type: object.row.outgoing_user_type,
        outgoing_user_bigo: object.row.outgoing_user_bigo,
        row_type: object.row.row_type,
        update_type: object.row.update_type
      })
    }
  };

  const userDeleteClick = (object) => {
    if(object.row.row_type === 'O'){
      setUpdateUserRows(prevRows => [...prevRows, {
        id: object.row.id,
        outgoing_user_id: object.row.outgoing_user_id,
        outgoing_user_name: object.row.outgoing_user_name,
        outgoing_user_dept_name: object.row.outgoing_user_dept_name,
        outgoing_user_position_name: object.row.outgoing_user_position_name,
        outgoing_user_type: object.row.outgoing_user_type,
        outgoing_user_bigo: object.row.outgoing_user_bigo,
        row_type:'O',
        update_type: 'D'
      }]);
    }else{
      setUpdateUserRows((updateUserRows) => updateUserRows.filter((data) => data.id !== object.row.id));
    }
    setUserRows((userRows) => userRows.filter((data) => data.id !== object.row.id));
  };

  const fileAddClick = (object) => {
    const input=document.createElement('input');
    input.type="file";
    input.multiple = true;
    input.style.display = 'none';
    document.body.appendChild(input);
    input.click();
    input.onchange = () => {

      for(var i=0; i<input.files.length; i++){
        realFiles.push(input.files[i]);
      }
      
      var array = [];
      for(var i=0; i<realFiles.length; i++){
        var tmp_sever_file_name = realFiles[i].name;
        var tmp_file_name = realFiles[i].name;
        var tmp_file_size = realFiles[i].size;
        var tmp_file_size_dp = appStore.convertFileSize(realFiles[i].size);
        var tmp_file_type = realFiles[i].type;
        var tmp_file_type_name  = appStore.convertFileTypeName(realFiles[i].type);
        var tmp_file_extension = tmp_sever_file_name.substring(tmp_sever_file_name.lastIndexOf('.')+1, tmp_sever_file_name.length);

        array.push({
          id: newFileID,
          file_name_sever: tmp_sever_file_name,
          file_size: tmp_file_size,
          file_type: tmp_file_type,
          file_extension: tmp_file_extension,
          file_type_name: tmp_file_type_name,
          file_name: tmp_file_name,
          file_size_dp: tmp_file_size_dp,
          reg_user_name: '',
          reg_datetime: '',
          row_type:'A',
          update_type: 'U'
        })
        newFileID = newFileID + 1;
      }
      setFileRows(array);
    }
  };

  const fileDeleteClick = (object) => {
    for(let i = 0; i < realFiles.length; i++) {
      if (realFiles[i].name === object.row.file_name_sever) {
        realFiles.splice(i, 1);
        break;
      }
    }

    if(object.row.row_type === 'O'){
      setUpdateFileRows(prevRows => prevRows.some(r => r.id === object.row.id && r.update_type === 'D') ? prevRows : [...prevRows, { 
        id: object.row.id,
        file_name_sever: object.row.outgoing_file_name_sever,
        file_size: object.row.outgoing_file_size,
        file_type: object.row.outgoing_file_type,
        file_extension: object.row.outgoing_file_extension,
        file_name: object.row.outgoing_file_name,
        file_type_name: object.row.outgoing_file_type_name,
        file_size_dp: object.row.outgoing_file_size_dp,
        reg_user_name: object.row.outgoing_file_user_name,
        reg_datetime: Moment(object.row.outgoing_file_user_datetime).format('YYYY-MM-DD HH:mm:ss'),
        row_type: 'O',
        update_type: 'D'
       }]);
    }else{
      setUpdateFileRows((updateFileRows) => updateFileRows.filter((data) => data.id !== object.row.id));
    }
    
    setFileRows((fileRows) => fileRows.filter((data) => data.id !== object.row.id));
  };

  const fileDownloadClick = (object) => {
    axios.post('/api/SaveCommon/FileDownload', new URLSearchParams({
      fileName: object.row.file_name,
      fileNameSever: object.row.file_name_sever
    }),
    { withCredentials: true, responseType: 'blob' })
    .then(function (response) {
        if(response.status === 200){
          const url = window.URL.createObjectURL(new Blob([response.data]));
					const link = document.createElement("a");
					link.href = url;
					link.setAttribute("download", object.row.file_name);
					document.body.appendChild(link);
					link.click();
        }else{
          appStore.capture();
        }
    })
    .catch(function (error) {
        appStore.capture();
        console.log("네트워크 실패", error);
    })
  };

  const handleOutgoingUpdate = (event) => {
    var status_str = ''
    var change_status = ''
    if(originRows[0].outgoing_status === 'S'){ 
      status_str = '취소'
      change_status = 'D'
    } else { 
      status_str = '원복'
      change_status = 'S'
    }

    Swal.fire({
      title: '출하번호 '+originRows[0].outgoing_number+' 출하 ' + status_str,
      text: '출하를 '+ status_str +' 하시겠습니까?',
      showCancelButton: true,
      confirmButtonText: '예', 
      cancelButtonText: '아니오',
      confirmButtonColor: '#0067a3',
      cancelButtonColor: '#d33',
    }).then(result => {
      if (result.isConfirmed) {
        if (appStore.loading) return;
        appStore.setLoading(true);
        
        axios.post('/api/p/Outgoing/Update', new URLSearchParams({
          cancel_outgoing_id: originRows[0].outgoing_id,
          change_status: change_status
        }),
        { withCredentials: true })
        .then(function (response) {
          if(response.status === 200){
            if(response.data === 'Y'){
              Swal.fire({
                title: '출하번호 '+originRows[0].outgoing_number+' ' + status_str + ' 완료',
                text: '정상적으로 출하가 '+status_str+' 되었습니다.',
                confirmButtonText: '확인',
                timer: 5000,
                timerProgressBar: true
              }).then((result) => {
                handleView();
              });
            }else{
              Swal.fire({
                title: '<p style="color:red">출하 원복 오류</p>',
                text: response.data,
                confirmButtonText: '확인'
              }).then((result) => {
                handleView();
              });
            }
            
          }else{
              appStore.capture();
          }
        })
        .catch(function (error) {
          appStore.capture();
          console.log("네트워크 실패", error);
        })
        .finally(() => {
          appStore.setLoading(false); 
        });
      }
    })
  }

  const handleOnCellClick = (params) => {
    if(params.field === 'outgoing_item_name' || params.field === 'outgoing_item_spec' ){
      setSelectModalTitle('품목 목록');
      setSelectItemModalOpen(true);
      setSelectItemData({
        id: params.row.id,
        outgoing_item_id: params.row.outgoing_item_id,
        outgoing_item_name: params.row.outgoing_item_name,
        outgoing_item_spec: params.row.outgoing_item_spec,
        outgoing_package_count: params.row.outgoing_package_count,
        outgoing_pack_rate: params.row.outgoing_pack_rate,
        outgoing_item_count: params.row.outgoing_item_count,
        outgoing_quality_exam_yn: params.row.outgoing_quality_exam_yn,
        outgoing_item_bigo: params.row.outgoing_item_bigo,
        row_type:params.row.row_type,
        update_type: params.row.update_type,
      })
    } else if(params.field === 'outgoing_user_name'){
      setSelectModalTitle('사용자 목록')
      setSelectUserModalOpen(true);
      setSelectUserData({
        id: params.row.id,
        outgoing_user_id: params.row.outgoing_user_id,
        outgoing_user_name: params.row.outgoing_user_name,
        outgoing_user_dept_name: params.row.outgoing_user_dept_name,
        outgoing_user_position_name: params.row.outgoing_user_position_name,
        outgoing_user_type: params.row.outgoing_user_type,
        outgoing_user_bigo: params.row.outgoing_user_bigo,
        row_type: params.row.row_type,
        update_type: params.row.update_type
      })
    }
  };

  const handlePartnerUserClick = (object) => {
    var partner_user_name = object.partner_user_name === undefined?'':object.partner_user_name
    var partner_user_phone = object.partner_user_phone === undefined?'':object.partner_user_phone
    var partner_user_email = object.partner_user_email === undefined?'':object.partner_user_email
    var partner_delivery_post = object.partner_head_address_post === undefined?'':object.partner_head_address_post
    var partner_delivery_address = object.partner_head_address === undefined?'':object.partner_head_address
    var partner_delivery_address_add = object.partner_head_address_addition === undefined?'':object.partner_head_address_addition

    const nextInputs = {
        ...inputs,
        ["outgoing_partner_id"]: object.id,
        ["outgoing_partner_name"]: object.partner_name,
        ["outgoing_partner_manager"]: partner_user_name,
        ["outgoing_partner_manager_phone"]: partner_user_phone,
        ["outgoing_partner_manager_mail"]: partner_user_email,
        ["outgoing_partner_delivery_post"]: partner_delivery_post,
        ["outgoing_partner_delivery_address"]: partner_delivery_address,
        ["outgoing_partner_delivery_address_add"]: partner_delivery_address_add,
    };
    setInputs(nextInputs);
  };
  
  const handleInputItemClick = (object) => {
    var doubleYN = 'N'
    for(let i = 0; i < itemRows.length; i++){
      if(itemRows[i].outgoing_item_id === object.id && selectItemData.id !== itemRows[i].id && object.id !== ''){
        doubleYN = 'Y'
      }
    }
    if(doubleYN === 'Y'){
      Swal.fire({
        title: '<p style="color:red">품목 '+object.item_name+' 중복</p>',
        text: '추가된 품목이므로 추가할 수 없습니다.',
        confirmButtonText: '확인'
      });
    } else {
      if(object.id !== selectItemData.outgoing_item_id){
        if (object.id === '') {
          processItemRowUpdate({
            id: selectItemData.id, outgoing_item_id: '', outgoing_item_name: '', outgoing_item_spec: '', outgoing_package_count: '', outgoing_pack_rate: '', outgoing_item_count: '',
            outgoing_quality_exam_yn: 'N', outgoing_item_bigo: '',
            row_type: selectItemData.row_type, update_type: selectItemData.update_type,
          }, { ...selectItemData });
        } else {
          processItemRowUpdate(
            {
              id: selectItemData.id,
              outgoing_item_id: object.id,
              outgoing_item_name: object.item_name,
              outgoing_item_spec: appStore.ITEM_FULL_SPEC_MAKE(object.item_spec, object.item_width, object.item_depth, object.item_height),
              outgoing_package_count: selectItemData.outgoing_package_count,
              outgoing_pack_rate: object.item_outgoing_package_count || 1, 
              outgoing_item_count: Number(selectItemData.outgoing_package_count || 0) * Number(object.item_outgoing_package_count || 1),
              outgoing_quality_exam_yn: selectItemData.outgoing_quality_exam_yn,
              outgoing_item_bigo: selectItemData.outgoing_item_bigo,
              row_type:selectItemData.row_type,
              update_type: selectItemData.update_type,
            },
            {
              id: selectItemData.id,
              outgoing_item_id: selectItemData.outgoing_item_id,
              outgoing_item_name: selectItemData.outgoing_item_name,
              outgoing_item_spec: selectItemData.outgoing_item_spec,
              outgoing_package_count: selectItemData.outgoing_package_count,
              outgoing_pack_rate: selectItemData.outgoing_pack_rate,
              outgoing_item_count: selectItemData.outgoing_item_count,
              outgoing_quality_exam_yn: selectItemData.outgoing_quality_exam_yn,
              outgoing_item_bigo: selectItemData.outgoing_item_bigo,
              row_type:selectItemData.row_type,
              update_type: selectItemData.update_type,
            }
          )
        }
      }
    }
  };

  const handleUserClick = (object) => {
    var doubleYN = 'N' 
    for(let i = 0; i < userRows.length; i++){
      if(userRows[i].outgoing_user_id === object.id && selectUserData.id !== userRows[i].id && object.id !== ''){
        doubleYN = 'Y'
      }
    }
    if(doubleYN === 'Y'){
      Swal.fire({
        title: '<p style="color:red">담당자 '+object.user_name+' 중복</p>',
        text: '추가된 담당자이므로, 중복으로 추가할 수 없습니다.',
        confirmButtonText: '확인'
      });
    } else {
      if(object.id !== selectUserData.user_id){
        processUserRowUpdate(
          {
            id : selectUserData.id,
            outgoing_user_id: object.id,
            outgoing_user_name: object.user_name,
            outgoing_user_dept_name: object.dept_name,
            outgoing_user_position_name: object.position_name,
            outgoing_user_type: (selectUserData.outgoing_user_type === 0 || selectUserData.outgoing_user_type === '') ? 178 : selectUserData.outgoing_user_type,
            outgoing_user_bigo: selectUserData.outgoing_user_bigo,
            row_type: selectUserData.row_type,
            update_type: selectUserData.update_type
          },
          {
            id : selectUserData.id,
            outgoing_user_id: selectUserData.outgoing_user_id,
            outgoing_user_name: selectUserData.outgoing_user_name,
            outgoing_user_type: (selectUserData.outgoing_user_type === 0 || selectUserData.outgoing_user_type === '') ? 178 : selectUserData.outgoing_user_type,
            outgoing_user_dept_name: selectUserData.outgoing_user_dept_name,
            outgoing_user_position_name: selectUserData.outgoing_user_position_name,
            outgoing_user_bigo: selectUserData.outgoing_user_bigo,
            row_type: selectUserData.row_type,
            update_type: selectUserData.update_type
          }
        )
      }
    }
  };

  const handleSave = (event) => {
    let msg = '';

    if(inputs.outgoing_partner_id === 0 || inputs.outgoing_partner_id === ''){
      msg = '출하처는 필수 선택 입니다.'
    }else if((inputs.outgoing_date) === '' || (inputs.outgoing_date) < '2025-01-01' || (inputs.outgoing_date).length != 10){
      msg = '출하일자 입력이 올바르지 않습니다.<br/>(입력 양식 : 2025-01-01 ~ )'
    }else if(inputs.outgoing_partner_manager_phone.trim() !== '' && !(/^\d{3}-(\d{3,4})-\d{4}$/).test(inputs.outgoing_partner_manager_phone.trim())){
      msg = '담당자 휴대번호 입력이 올바르지 않습니다.<br/>(입력 양식 : 010-숫자3,4자리-숫자4자리)';
    }else if(inputs.outgoing_partner_manager_mail.trim() !== '' && !(/^[-A-Za-z0-9_]+[-A-Za-z0-9_.]*[@]{1}[-A-Za-z0-9_]+[-A-Za-z0-9_.]*[.]{1}[A-Za-z]{1,5}$/).test(inputs.outgoing_partner_manager_mail.trim())){
      msg = '담당자 E-Mail 입력이 올바르지 않습니다.';
    }

    if(updateItemRows.length === 0){ 
      msg = '출하 품목이 존재하지 않습니다.';
    } else if(updateItemRows.length > 0 && msg === ''){ 
      for(let i = 0; i < updateItemRows.length; i++) {
        const outgoing_item_id = updateItemRows[i].outgoing_item_id;
        const outgoing_package_count = updateItemRows[i].outgoing_package_count;

        if(outgoing_item_id === 0 || outgoing_item_id === '') {
          msg = '선택되지 않는 출하 품목이 존재합니다.';
          break;
        }
        if(outgoing_package_count === 0 || outgoing_package_count === '' || outgoing_package_count === null) {
          msg = '입력되지 않는 수량이 존재합니다.';
          break;
        }
        if(outgoing_package_count < 0) {
          msg = '수량은 음수가 될 수 없습니다.';
          break;
        }
      }
    }

    if(updateUserRows.length > 0 && msg === ''){
      for(let i = 0; i < updateUserRows.length; i++) {
        const outgoing_user_id = updateUserRows[i].outgoing_user_id;
        const outgoing_user_type = updateUserRows[i].outgoing_user_type;
        
        if(outgoing_user_id === 0 || outgoing_user_id === '') {
          msg = '선택되지 않는 담당자명이 존재합니다.';
          break;
        }
        if(outgoing_user_type === 0 || outgoing_user_type === '') {
          msg = '선택되지 않는 담당자유형이 존재합니다.';
          break;
        }
      }
    }

    if(msg !== ''){
      Swal.fire({
        title: '<p style="color:red">출하 수정 오류</p>',
        html: msg,
        confirmButtonText: '확인'
      });
    }else{
      if (appStore.loading) return;
      appStore.setLoading(true);
      
      axios.post("/api/p/Outgoing/Reg", {inputs, updateItemRows, updateUserRows, updateLotRows} ,
      { withCredentials: true })
      .then(function (response) {
        if(response.status === 200){
          var selectID = response.data;
          if(String(selectID) === '-1'){
            Swal.fire({
              title: '<p style="color:red">출하 LotNo 변경 발생</p>',
              text: '출하 등록할 LotNo의 변경이 발생했습니다.',
              confirmButtonText: '확인'
            });
          }else{
            if(updateFileRows.length > 0) {

              const formData = new FormData();
              formData.append('selectID', selectID);
              formData.append('folder', 'Outgoing');
              formData.append('type', 'Update');
              formData.append('updateFileRows', JSON.stringify(updateFileRows));
              
              for(var i=0; i<realFiles.length; i++){            
                formData.append('files', realFiles[i]);
              }
              
              axios.post('/api/SaveCommon/GridFileSave'
                  , formData
                  , { headers: { 'Content-Type': 'multipart/form-data' } 
              }).then(response => {
                Swal.fire({
                  title: '출하 수정 완료',
                  text: '정상적으로 출하가 수정 되었습니다.',
                  confirmButtonText: '확인',
                  timer:5000,
                  timerProgressBar: true
                }).then((result) => {
                  handleView();
                });
              }).catch(error => {
                appStore.capture();
              });

            }else{
              Swal.fire({
                title: '출하 수정 완료',
                text: '정상적으로 출하가 수정 되었습니다.',
                confirmButtonText: '확인',
                timer:5000,
                timerProgressBar: true
              }).then((result) => {
                handleView();
              });
            }
          }
        }else{
          appStore.capture();
        }
      })
      .catch(function (error) {
          appStore.capture();
      })
      .finally(() => {
          appStore.setLoading(false); 
      });

    }
  };
  
  const fRow = { display: 'flex', gap: '30px' };
  const fCell = { display: 'flex', alignItems: 'center', flex: 1, minWidth: 0 };
  const fLabel = { width: '120px', flexShrink: 0, fontWeight: 'bold', fontSize: '15px', color: '#333', whiteSpace: 'nowrap' };
  const fInput = { flex: 1, minWidth: 0, height: '40px', border: '1px solid #ccc', borderRadius: '4px', padding: '0 12px', fontSize: '15px', boxSizing: 'border-box' };

  return (
    <TabContext value={tabID}>
      <div style={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column', backgroundColor: '#fff', overflow: 'hidden' }}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider', display: 'flex', justifyContent: 'space-between', alignItems: 'center', backgroundColor: '#fafafa', minHeight: '50px', paddingRight: '20px' }}>
          <TabList onChange={handleTabID} style={{ paddingLeft: '20px'}}>
                <Tab label="정보" value="1" />
                <Tab label="품목" value="2" />
                <Tab label="Lot" value="3" />
                <Tab label="담당자" value="4" />
                <Tab label="파일" value="5" />
          </TabList>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  
                    {updateFlag &&
                     (originRows[0].outgoing_status === 'S'?
                      <Button 
                        onClick={ handleOutgoingUpdate }
                        className="btn-p btn-u"
                        
                        sx={{  
                            m: 0.5, 
                            fontSize: 14, 
                            color: "white", 
                            borderColor: "orange", 
                            backgroundColor: "orange",
                            ":hover": { boxShadow: "2px 2px 2px orange" , backgroundColor: "orange", borderColor: "orange"}
                        }} 
                        variant="outlined">
                        출하취소
                      </Button>
                    :
                      <Button 
                        onClick={ handleOutgoingUpdate }
                        className="btn-p btn-u"
                        
                        sx={{  
                            m: 0.5, 
                            fontSize: 14, 
                            color: "white", 
                            borderColor: "#8041D9", 
                            backgroundColor: "#8041D9",
                            ":hover": { boxShadow: "2px 2px 2px #8041D9" , backgroundColor: "#8041D9", borderColor: "#8041D9"}
                        }} 
                        variant="outlined">
                        출하원복
                      </Button>
                      )
                    }
                    
                    
                      {updateFlag &&
                      (originRows[0].outgoing_status === 'S'?
                      <Button 
                        onClick={handleSave}
                        className="btn-p btn-u"
                        sx={{  
                            m: 0.5, 
                            fontSize: 14, 
                            color: "white", 
                            borderColor: "#FF3636", 
                            backgroundColor: "#FF3636",
                            ":hover": { boxShadow: "2px 2px 2px #FF3636" , backgroundColor: "#FF3636", borderColor: "#FF3636"}
                        }} 
                        variant="outlined">
                        수정
                      </Button>:<></>
                      )}
                    
                  </div>
        </Box>
        <div ref={tabPanelRef} style={{ flex: 1, overflow: 'hidden', backgroundColor: '#fff', minHeight: 0 }}>
          <TabPanel value="1" style={{ height: '100%', overflow: 'auto', padding: 0 }}>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '20px', padding: '28px 34px', boxSizing: 'border-box', width: '100%' }}><div style={fRow}><div style={fCell}><label style={fLabel}>출하번호</label><input type="text" placeholder="출하번호" value={inputs.outgoing_number} name="outgoing_number" onChange={(e) => onChange(e) } autoComplete="off" disabled={true} style={{ ...fInput, fontWeight: 'bold', color: 'black', backgroundColor: '#f5f5f5' }} /></div><div style={fCell}><label style={fLabel}>수주번호</label><input type="text" placeholder="수주번호" value={inputs.outgoing_order_number} name="outgoing_order_number" onChange={(e) => onChange(e) } autoComplete="off" disabled={true} style={{ ...fInput, fontWeight: 'bold', color: 'black', backgroundColor: '#f5f5f5' }} /></div></div><div style={fRow}><div style={fCell}><label style={fLabel}>출하일자 <span style={{ color: 'red' }}>*</span></label><input type="date" value={inputs.outgoing_date} name="outgoing_date" onChange={(e) => onDateChange(e) } autoComplete="off" style={fInput} /></div><div style={fCell}><label style={fLabel}>출하처 <span style={{ color: 'red' }}>*</span></label><input type="text" placeholder="출하처" value={inputs.outgoing_partner_name} name="outgoing_partner_name" onChange={(e) => onChange(e) } onClick={(e) => onClick(e) } autoComplete="off" style={{ ...fInput, backgroundColor: '#EFEFEF4D', cursor: 'pointer' }} readOnly /></div></div><div style={{ display: 'flex', alignItems: 'center' }}><label style={fLabel}>출하처 담당자</label><div style={{ display: 'flex', flex: 1, minWidth: 0, gap: '12px' }}><input type="text" placeholder="이름" value={inputs.outgoing_partner_manager} name="outgoing_partner_manager" onChange={(e) => onChange(e) } autoComplete="off" style={{ ...fInput, flex: 1 }} /><input type="text" placeholder="휴대폰번호" value={inputs.outgoing_partner_manager_phone} name="outgoing_partner_manager_phone" onChange={(e) => onHypenChange(e) } autoComplete="off" style={{ ...fInput, flex: 2 }} /><input type="text" placeholder="메일주소" value={inputs.outgoing_partner_manager_mail} name="outgoing_partner_manager_mail" onChange={(e) => onChange(e) } autoComplete="off" style={{ ...fInput, flex: 2 }} /></div></div><div style={{ display: 'flex', alignItems: 'center' }}><label style={fLabel}>출하처 배송지</label><div style={{ display: 'flex', flex: 1, minWidth: 0, gap: '12px' }}><input type="text" placeholder="우편번호" value={inputs.outgoing_partner_delivery_post} name="outgoing_partner_delivery_post" onChange={(e) => onChange(e) } autoComplete="off" style={{ ...fInput, flex: '0 0 150px' }} /><input type="text" placeholder="주소" value={inputs.outgoing_partner_delivery_address} name="outgoing_partner_delivery_address" onChange={(e) => onChange(e) } autoComplete="off" style={{ ...fInput, flex: 1 }} /></div></div><div style={{ display: 'flex', alignItems: 'center' }}><label style={fLabel}></label><input type="text" placeholder="상세주소" value={inputs.outgoing_partner_delivery_address_add} name="outgoing_partner_delivery_address_add" onChange={(e) => onChange(e) } autoComplete="off" style={fInput} /></div><div style={{ display: 'flex', alignItems: 'flex-start' }}><label style={{ ...fLabel, marginTop: '10px' }}>비고</label><textarea placeholder="비고" name="outgoing_bigo" value={inputs.outgoing_bigo} onChange={(e) => onChange(e) } style={{ flex: 1, minWidth: 0, height: '110px', border: '1px solid #ccc', borderRadius: '4px', padding: '10px 12px', fontSize: '15px', resize: 'none', boxSizing: 'border-box' }} autoComplete="off"></textarea></div></div>
            </TabPanel>
            <TabPanel value="2" style={ { height: tabPanelHeight } }>
              <div className="modal_grid">
                <DataGrid
                  apiRef={apiRef}
                  rows={itemRows}
                  columns={itemColumns}
                  columnVisibilityModel={itemColumnVisibilityModel}
                  editMode='cell'  
                  processRowUpdate={processItemRowUpdate}        
                  onProcessRowUpdateError={(error) => error}
                  AlternatingRowBackground="LavenderBlush"
                  rowsPerPageOptions={[20, 50, 100]}
                  initialState={{ 
                      density: 'compact'
                  }}
                  slots={{
                      noRowsOverlay: GridNoRow,
                  }}
                  onCellClick={handleOnCellClick}
                  disableColumnSorting 
                />
              </div>
            </TabPanel>
            <TabPanel value="3" style={ { height: tabPanelHeight } }>
              <div className="modal_grid">
                <DataGrid
                  apiRef={apiRef}
                  rows={lotRows}
                  columns={lotColumns}
                  columnVisibilityModel={lotColumnVisibilityModel}
                  editMode='cell'  
                  processRowUpdate={processLotRowUpdate}
                  onProcessRowUpdateError={(error) => error}
                  AlternatingRowBackground="LavenderBlush"
                  rowsPerPageOptions={[20, 50, 100]}
                  initialState={{ 
                      density: 'compact'
                  }}
                  slots={{
                      noRowsOverlay: GridNoRow,
                  }}
                  onCellClick={handleOnCellClick}
                  disableColumnSorting 
                />
              </div>
            </TabPanel>
            <TabPanel value="4" style={ { height: tabPanelHeight } }>
              <div className="modal_grid">
                <DataGrid
                  apiRef={apiRef}
                  rows={userRows}
                  columns={userColumns}
                  columnVisibilityModel={userColumnVisibilityModel}
                  editMode='cell'  
                  processRowUpdate={processUserRowUpdate}        
                  onProcessRowUpdateError={(error) => error}
                  AlternatingRowBackground="LavenderBlush"
                  rowsPerPageOptions={[20, 50, 100]}
                  initialState={{ 
                      density: 'compact'
                  }}
                  slots={{
                      noRowsOverlay: GridNoRow,
                  }}
                  onCellClick={handleOnCellClick}
                  disableColumnSorting 
                />
              </div>
            </TabPanel>
            <TabPanel value="5" style={ { height: tabPanelHeight } }>
              <div className="modal_grid">
                <DataGrid
                  rows={fileRows}
                  columns={fileColumns}
                  columnVisibilityModel={fileColumnVisibilityModel}
                  editMode='cell'       
                  onProcessRowUpdateError={(error) => error}
                  AlternatingRowBackground="LavenderBlush"
                  rowsPerPageOptions={[20, 50, 100]}
                  initialState={{ 
                      density: 'compact'
                  }}
                  slots={{
                      noRowsOverlay: GridNoRow,
                  }}
                  disableColumnSorting 
                />
              </div>
            </TabPanel>
          </div>
        </div>
        {isSelectPartnerModalOpen && (<PartnerUserSelectModal
          onClose={() => {
              setSelectPartnerModalOpen(false);
          }}
          title={selectmodalTitle}
          handlePartnerUserClick={handlePartnerUserClick}
          />)}

        {isSelectItemModalOpen && (<ItemSelectModal hideDimensions={true}
          onClose={() => {
              setSelectItemModalOpen(false);
          }}
          title={selectmodalTitle}
          handleInputItemClick={handleInputItemClick}
          />)}
        
        {isSelectUserModalOpen && (<UserSelectModal
          onClose={() => {
              setSelectUserModalOpen(false);
          }}
          title={selectmodalTitle}
          handleUserClick={handleUserClick}
          />)}
    </TabContext>
  );
}

export default TAB_OutgoingUpdate;